var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.isActive },attrs:{"href":"javascript:void(0)"},on:{"click":_vm.handleClick}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }